module.exports = __webpack_public_path__ + "img/layer_prizes.26cdc3de.png";